import React, { useState, useRef, useEffect, useMemo } from 'react';
import JoditEditor from "jodit-react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import ReturnClass from "../pages/Signup/ReturnClass";
import axios from "axios"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Spinner from 'react-spinner-material';

function MasterAuthor() {

    const apiurl = window.SERVICE_URL;

    const editor = useRef(null)
    const [content, setContent] = useState('')

    const [AddAuthor, setAddAuthor] = useState(false);
    const AddAuthorClose = () => setAddAuthor(false);
    const handleAddAuthor = () => setAddAuthor(true);

    const [EditAuthor, setEditAuthor] = useState(false);
    const EditAuthorClose = () => setEditAuthor(false);
    const handleEditAuthor = () => setEditAuthor(true);

    if (localStorage.getItem("loginsession") != null) {
        const res = JSON.parse(localStorage.getItem("loginsession"));
        ReturnClass.EmailID = res.EmailID;
        ReturnClass.MobileNumber = res.MobileNumber;
        ReturnClass.AccessToken = res.AccessToken;
        ReturnClass.UserID = res.UserID;
        ReturnClass.PartnerID = res.PartnerID;
    }

    const encPartnerID = ReturnClass.PartnerID;
    const [data, dataSet] = useState([]);

    const [AuthorById, AuthorByIdSet] = useState([]);
    useEffect(() => {
    }, [AuthorByIdSet]);

    useEffect(() => {
        GetAllAuthor();
    }, [dataSet]);

    function spinner(e, isTrue) {
        if (isTrue) {
            e.setAttribute("style", "visibility: visible; display: block;");
        } else {
            e.setAttribute("style", "visibility: hidden; display: none;");
        }
    }

    function validateFormUpdate(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Author Name";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            // AddAuthors();
            UpdateAuthors();

            status = true;
        }
        return status;
    }


    function validateForm(e) {
        var name = document.f1.name.value;

        var status = false;
        if (name == "") {
            document.getElementById("nameVal").style.color = "red";
            document.getElementById("nameVal").innerHTML =
                "Please Enter Author Name";
            status = false;
        } else {
            document.getElementById("nameVal").innerHTML = "";
            AddAuthors();
            //UpdateAuthors();

            status = true;
        }
        return status;
    }

    async function GetAllAuthor() {
        var spi = document.getElementById('spi');
        spinner(spi, true);

        await axios.get(apiurl+`api/GetAllAuthorInfo?PartnerID=` + encPartnerID,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`
                }
            }).then(function (response) {
                spinner(spi, false);
                dataSet(response.data);

            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const AddAuthors = async () => {

        var Authornames = document.getElementById("AuthorName").value;
        var Authordescriptions = document.getElementById("AuthorDescription").value;
        const AuthorForm = {
            Id: 0,
            Name: Authornames,
            Description: Authordescriptions,
            QuestionCount: 0,
            PartnerID: 0,
            CreatedDate: new Date(),
            Active: true,
            encPartnerID: ReturnClass.PartnerID
        };

        await axios.post(apiurl + `api/AddAuthorInfo`, AuthorForm,
            {
                headers:
                {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                    "Content-Type": "application/json"
                },
            })
            .then(function (result) {

                toast.success(result.data.outMessage);
                GetAllAuthor();
                AddAuthorClose();
            })
            .catch(error => {
                console.log(error.response)
            });
    };

    async function GetAuthorInfoByID(AuthorID) {
        AuthorByIdSet([]);
        await axios.get(apiurl +`api/GetAuthorInfoByID?PartnerID=${encPartnerID}&Id=${AuthorID}`,
            {
                headers: {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                },
            }).then(function (response) {
                AuthorByIdSet(response.data);
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    const UpdateAuthors = async () => {

        var Authornames = document.getElementById("AuthorName").value;
        var Authordescriptions = document.getElementById("AuthorDescription").value;
        var AuthorID = document.getElementById("Id").value;

        const UpdateAuthorForm = {
            Id: AuthorID,
            Name: Authornames,
            Description: Authordescriptions,
            QuestionCount: 0,
            PartnerID: 0,
            CreatedDate: new Date(),
            Active: true,
            encPartnerID: ReturnClass.PartnerID
        };

        await axios.post(apiurl + `api/AddAuthorInfo`, UpdateAuthorForm,
            {
                headers:
                {
                    "Authorization": `Bearer ${ReturnClass.AccessToken}`,
                    "Content-Type": "application/json"
                },
            })
            .then(function (result) {

                toast.success(result.data.outMessage);
                GetAllAuthor();
                EditAuthorClose();
            })
            .catch(error => {
                console.log(error.response)
            });
    };

    return (
        <>
            <ToastContainer />
            <div className="alert alert-light d-flex align-items-center mb-3 px-4">
                <h5
                    className="yoc-subheader__title text-uppercase mb-0 pl-md-2"
                    style={{ fontSize: "14px" }}>
                    Home
                </h5>
                <span className="seperator-danger ml-lg-3 ml-md-3 ml-sm-3 ml-2 mr-2 text-danger"></span>
                <span className="text-danger font-weight-500 f13">Author Entities</span>
            </div>
            <div className="yoc-subheader__main bg-white px-3 mb-3 py-3">
                <Link
                    to="/manage-user"
                    className="btn btn-pill btn-upper font-weight-normal ad-btn text-uppercase btn-orange waves-effect waves-light"
                >
                    Master Settings
                </Link>
                <Link
                    to="/manage-user"
                    className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                >
                    Admin/ Users
                </Link>
                <a
                    type="text"
                    href="#"
                    className="btn btn-pill btn-upper btn-bold text-uppercase waves-effect waves-light"
                >
                    Admin/Users Rights
                </a>
            </div>
            <div className="row">
                <div className="col-lg-12 col-xs-12 order-lg-2 order-xl-2">
                    <div className="alert alert-light d-flex align-items-center mb-0 px-3">
                        <span
                            className="yoc-badge yoc-badge--inline yoc-badge--pill yoc-badge--success yoc-badge--rounded cursor-pointer"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            MASTER ENTERIES
                        </span>
                        <div
                            className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-md custom_dropdown"
                            x-placement="bottom-end"
                            style={{
                                position: "absolute",
                                willChange: "transform",
                                top: "0px",
                                left: "0px",
                                transform: "translate3d(24px, 26px, 0px)",
                            }}>

                            <ul className="yoc-nav p-3">
                                <li className="yoc-nav__head d-block text-center headingList">
                                    Select Master Entry
                                    <i className="flaticon2-information" data-toggle="yoc-tooltip" data-placement="right" title="" data-original-title="Click to learn more..."></i>
                                </li>
                                <li className="yoc-nav__item  mt-2">
                                    <Link to="/master-question-type" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk custom-lnk">Question's Type</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item  mt-2">
                                    <Link to="/master-settings" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk ">Exam List</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-levels" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Difficulty Level</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-question" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Question Source</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-language" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Language</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-author" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Authors</span>
                                    </Link>
                                </li>

                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-concept" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">Concept</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__item mt-2">
                                    <Link to="/master-university" className="yoc-menu__link ">
                                        <span className="yoc-nav__link-text custom-lnk">University</span>
                                    </Link>
                                </li>
                                <li className="yoc-nav__separator"></li>
                            </ul>
                        </div>
                        <span className="seperator ml-lg-3 ml-md-3 ml-sm-3 ml-2"></span>
                        <h5 className="yoc-subheader__title text-uppercase mt-2">Author</h5>
                        <div style={{ fontSize: "12px", padding: "10px 6px" }}
                            onClick={handleAddAuthor}
                            className="yoc-badge yoc-badge--inline yoc-badge--pill yoc-badge--info yoc-badge--rounded cursor-pointer ml-2"> <i
                                className="fa fa-plus "
                                title="Add new level"
                                aria-hidden="true"

                            ></i></div>
                    </div>
                    <div className="yoc-portlet yoc-portlet--height-fluid yoc-portlet--mobile custom-side">
                        <div className="yoc-portlet__body yoc-portlet__body--fit ">
                            <div
                                className="yoc-datatable yoc-datatable--default   yoc-datatable--loaded table-responsive"
                                id="yoc_datatable_latest_orders"
                            >
                                <table className="table " style={{ display: "block" }}>
                                    <thead className="yoc-datatable__head">
                                        <tr className="yoc-datatable__row" style={{ left: "0px" }}>
                                            <th
                                                data-field="ShipName"
                                                data-autohide-disabled="false"
                                                className="yoc-datatable__cell yoc-datatable__cell--sort "
                                            >
                                                <span className="thHeader">Name</span>
                                            </th>
                                            <th
                                                data-field="ShipDate"
                                                className="yoc-datatable__cell yoc-datatable__cell--sort "
                                            >
                                                <span className="thHeader">Description</span>
                                            </th>
                                            <th
                                                data-field="Status"
                                                className="yoc-datatable__cell yoc-datatable__cell--sort "
                                            >
                                                <span className="thHeader">No. of Questions</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="yoc-datatable__body ps ps--active-y">
                                        <tr id="spi" >
                                            <Spinner size={120} spinnerColor={"#333"} spinnerWidth={2} />
                                        </tr>
                                        {data.map((Author, key) => (
                                            <tr key={key} className="yoc-datatable__row" style={{ left: "0px" }}>
                                                <td
                                                    data-field="ShipName"
                                                    data-autohide-disabled="false"
                                                    className="yoc-datatable__cell"
                                                    style={{ width: "329px" }}
                                                >
                                                    <div className="yoc-user-card-v2 d-flex">
                                                        <div className="yoc-user-card-v2__pic">
                                                            <strong>{Author.name}</strong>
                                                        </div>
                                                        <div
                                                            className="dropdown ml-sm-4"
                                                            style={{
                                                                overflow: "visible",
                                                                position: "relative",
                                                                width: "80px"
                                                            }}
                                                        >
                                                            <a
                                                                data-toggle="dropdown"
                                                                className="btn btn-sm btn-clean btn-icon btn-icon-md"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="flaticon-more-1"></i>
                                                            </a>
                                                            <div
                                                                className="dropdown-menu dropdown-menu-right ml-sm-4"
                                                                x-placement="bottom-end"
                                                                style={{
                                                                    position: "absolute",
                                                                    willChange: "transform",
                                                                    top: "0px",
                                                                    left: "0px",
                                                                    transform: "translate3d(24px, 26px, 0px)"
                                                                }}
                                                            >
                                                                <ul className="yoc-nav">
                                                                    <li className="yoc-nav__item">
                                                                        <a
                                                                            className="yoc-nav__link"
                                                                            onClick={() => { GetAuthorInfoByID(Author.id); handleEditAuthor(); }}
                                                                        >
                                                                            <i className="yoc-nav__link-icon flaticon2-contract"></i>
                                                                            <span className="yoc-nav__link-text">
                                                                                Edit Author
                                                                            </span>
                                                                        </a>
                                                                    </li>
                                                                    <li className="yoc-nav__item">
                                                                        <a className="yoc-nav__link" href="#">
                                                                            <i className="yoc-nav__link-icon flaticon2-trash"></i>
                                                                            <span className="yoc-nav__link-text">
                                                                                Delete
                                                                            </span>
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td
                                                    className="yoc-datatable__cell"
                                                    style={{ width: "420px" }}
                                                >
                                                    <span className="pr-sm-3">
                                                        {Author.description}
                                                    </span>
                                                </td>
                                                <td
                                                    data-field="Actions"
                                                    data-autohide-disabled="false"
                                                    className="yoc-datatable__cell "
                                                >
                                                    <span className="pr-sm-3">3422</span>
                                                </td>
                                            </tr>
                                        )).reverse()}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={AddAuthor}
                onHide={AddAuthorClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>ADD AUTHOR</Modal.Title>
                        <Button onClick={AddAuthorClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="AuthorName"
                                    name="name"
                                />
                                <span id="nameVal"></span>
                            </div>
                        </div>

                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={content}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="AuthorDescription"
                                    name="Description"
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateForm}>
                            Add
                        </Button>
                        <Button variant="primary" onClick={AddAuthorClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal
                show={EditAuthor}
                onHide={EditAuthorClose}
                backdrop="static"
                keyboard={false}
            >
                <form className="yoc-form yoc-form--fit yoc-form--label-right" name="f1">
                    <Modal.Header>
                        <Modal.Title>EDIT AUTHOR</Modal.Title>
                        <Button onClick={EditAuthorClose}>X</Button>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-3">
                                <p>Name:</p>
                            </div>
                            <div className="col-md-9">
                                <input
                                    type="hidden"
                                    className="form-control "
                                    placeholder="Id"
                                    aria-describedby=""
                                    id="Id"
                                    name="Id"
                                    defaultValue={AuthorById.id}
                                />
                                <input
                                    type="text"
                                    className="form-control "
                                    placeholder="Name"
                                    aria-describedby=""
                                    id="AuthorName"
                                    name="name"
                                    defaultValue={AuthorById.name}
                                />
                                <span id="nameVal"></span>
                            </div>
                        </div>

                        <div className="form-group row mb-3 yoc-margin-t-10">

                            <div className="col-md-12">
                                <p>Description</p>
                                <JoditEditor
                                    ref={editor}
                                    value={AuthorById.description}
                                    tabIndex={1} // tabIndex of textarea
                                    onBlur={newContent => setContent(newContent)} // preferred to use only this option to update the content for performance reasons
                                    onChange={newContent => { }}
                                    id="AuthorDescription"
                                    name="Description"
                                />
                            </div>

                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="primary" onClick={validateFormUpdate}>
                            Update
                        </Button>
                        <Button variant="primary" onClick={EditAuthorClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default MasterAuthor